import objectFitImages from 'object-fit-images'
import splitting from 'splitting'
import isMobile from 'ismobilejs'

import Accordion from 'accordion/src/accordion'
import 'accordion/src/accordion.css'

import form from './form'
import lazyLoad from './lazy-load'
import bigCoverButtons from './big-cover-buttons'
import fourQuarters from './four-quarters'
import tabs from './tabs'
import ChangeImageOnHover from './change-image-on-hover'
import tabsBackgroundColor from './tabs-background-color'
import cursor from './cursor'
import dropdown from './dropdown'
import horizontalScrollByDrag from './horizontal-scroll-by-drag'
import stickyFooter from './sticky-footer'
import pauseVideoOnScroll from './pause-video-on-scroll'
import carouselObserver from './carousel-observer'
import offersVueApp from './offers-vue-app'
import shuffeWithLoadMore from './shuffle-with-load-more'

const onPageLoad = page => {
  objectFitImages()
  form(page)

  // lazyLoad.observer.disconnect()
  page
    .querySelectorAll('[data-lazy-image]')
    .forEach(img => lazyLoad.observer.observe(img))

  page
    .querySelectorAll('[data-big-cover-buttons]')
    .forEach(el => bigCoverButtons(el))

  splitting()

  page
    .querySelectorAll('[data-four-rectangles]')
    .forEach(el => fourQuarters(el))

  carouselObserver.disconnect()
  page
    .querySelectorAll('[data-carousel]')
    .forEach(el => carouselObserver.observe(el))

  // before tabs
  page
    .querySelectorAll('[data-tabs-background-color]')
    .forEach(el => tabsBackgroundColor(el))

  // important - this should go after tabsBackgroundColor
  page.querySelectorAll('[data-tabs-wrapper]').forEach(el => tabs(el))

  page.querySelectorAll('[data-image-changer-wrapper]').forEach(el => {
    new ChangeImageOnHover(el)
  })

  page.querySelectorAll('[data-stop-click-propagation]').forEach(el =>
    el.addEventListener('click', e => {
      e.stopPropagation()
    })
  )

  page.querySelectorAll('[data-cursor]').forEach(el => {
    el.addEventListener('mouseenter', () => {
      if ('cursorColorClass' in el.dataset) {
        cursor.setColorClass(el.dataset.cursorColorClass)
      }
      cursor.toggleDisplay(true)
    })
    el.addEventListener('mouseleave', () => {
      cursor.toggleDisplay(false)
    })
  })

  dropdown(page)

  page.querySelectorAll('[data-horizontal-scroll-by-drag]').forEach(el => {
    horizontalScrollByDrag(el)
  })

  stickyFooter.checkIfDisabled(page)

  page.querySelectorAll('[data-accordion]').forEach(el => new Accordion(el))

  page
    .querySelectorAll('[data-shuffle-with-load-more]')
    .forEach(shuffeWithLoadMore)

  const isDesktop = !isMobile().any
  page.querySelectorAll('[data-consistent-video-poster]').forEach(el => {
    // <video> element without poster and autoplay is not displayed on iOS, but on Android first frame of video is displayed
    // we take control over the situation by relying on ismobilejs
    const poster = el.querySelector('img')
    const video = el.querySelector('video')

    if (!video && poster) {
      poster.src = poster.dataset.src
    }

    if (video && poster && isDesktop) {
      poster.style.display = 'none'
      video.src = video.dataset.src
    }

    if (video && poster && !isDesktop) {
      video.style.display = 'none'
      poster.src = poster.dataset.src
    }
  })

  if (isDesktop) {
    pauseVideoOnScroll(page.querySelectorAll('.fullscreen-bg video'))
    page
      .querySelectorAll('[data-desktop-autoplay]')
      .forEach(video => video.play())
  }
}

export const withVue = (page, callback) => {
  const promises = Array.from(page.querySelectorAll('[data-vue-app]')).map(
    el => new Promise(resolve => offersVueApp(el, resolve))
  )

  Promise.all(promises).then(() => callback(page))
}

export default page => withVue(page, onPageLoad)
